import React, { useMemo } from 'react';

import Autocomplete from 'src/components/input/autocomplete/Autocomplete';
import useTeamMembers from 'src/services/api/team/members/use-team-members';
import {ImageOff} from 'lucide-react';

type Props = Omit<React.ComponentProps<typeof Autocomplete>, 'options'>;

export default function SelectTeamMember({
    value,
    ...props
}: Props) {
    const { data: teamMembers } = useTeamMembers();

    const options = useMemo(() => {
        if (!teamMembers) {
            return [];
        }

        return teamMembers
            .map((teamMember) => ({
                value: teamMember.uuid,
                label: teamMember.name,
            }));
    }, [teamMembers]);

    return (
        <Autocomplete {...props} value={value} options={options} renderOption={(_props, option) => {
            const photoUrl = teamMembers?.find((m) => m.uuid === option.value)?.profile_photo_url;
            return (<li {..._props} key={option.value}>
                <div style={{backgroundColor: 'lightgrey', borderRadius: '50%', width: 25, height: 25, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', marginRight: 5}}>
                    {photoUrl ? (
                        <img src={photoUrl} alt="image" width={25} height={25} />
                    ) : <ImageOff color="grey" />}
                </div>
                {option.label}
            </li>
            );
        }}
        />
    );
}
